import  { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Link,
  createTheme,
  ThemeProvider
} from "@mui/material";
import register from "../../../assets/images/register.png";
import logo from "../../../assets/images/logo.jpeg"
import { ArrowBack } from "@mui/icons-material";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#d15242"
        },
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: "#d15242"
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: "#d15242"
          }
        }
      },
    },
  },
})
export default function RegistrationForm({ data, updateData, onNext }) {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    const newVal = type === "checkbox" ? checked : value;
    updateData({ [name]: newVal });

    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validateForm = () => {
    const newErrors = {
      firstName: !data.first_name,
      lastName: !data.last_name,
      email: !data.email || !/\S+@\S+\.\S+/.test(data.email),
      country: !data.country,
      city: !data.city,
      agreeTerms: !data.agreeTerms,
      agreePrivacy: !data.agreePrivacy,
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onNext();
    } else {
      const firstErrorField = Object.keys(errors).find((key) => errors[key]);
      if (firstErrorField) {
        document.getElementsByName(firstErrorField)[0]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  const isFormComplete = () => { 
    return (
      data.first_name &&
      data.last_name &&
      data.email &&
      data.country &&
      data.city &&
      data.agreeTerms &&
      data.agreePrivacy
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <Grid
          item
          xs={false}
          sm={false}
          md={6}
          sx={{
            backgroundImage: `url(${register})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: { xs: "none", md: "block" },
          }}
        >

        </Grid>

        <Grid item xs={12} md={6} component={Paper} elevation={0} square>
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%", px: 4, py: 6, maxWidth: 600, mx: "auto", overflowY: "auto" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4, }}>
              <Link component={RouterLink} to={"/talents"} sx={{ textDecoration: "none", color: "inherit" }}>
                <Box sx={{ display: "flex", alignItems: "start", flexDirection: "row", color: "black" }} >
                  <ArrowBack sx={{ mr: 1, "&:hover": { backgroundColor: "#E84A1C", color: "#ffffff" } }} />
                  <Typography sx={{ textTransform: "none"}}>Back</Typography>
                </Box>
              </Link>
              <Box sx={{ width: "100%", maxWidth: 100, mx: 0 }}>
                <Link component={RouterLink} to={"/"}>
                  <img
                    src={logo}
                    alt="E1X Academy Logo"
                    width={100}
                    height={50}
                    style={{ objectFit: "contain" }}
                  />
                </Link>
              </Box>
            </Box>

            <Typography component="h1" variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
              Thank you for your interest in E1X Talent Matching
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              Please fill out the form below, so we can better understand your needs and connect you with the right opportunities.
            </Typography>

            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ width: "100%" }}>
              <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> First Name</Typography>
              <TextField placeholder="Enter Your First Name" fullWidth name="first_name" value={data.first_name} onChange={handleChange} required sx={{ mb: 2 }} error={errors.first_name}
                helperText={errors.first_name ? "First name is required" : ""} />

              <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Last Name</Typography>
              <TextField placeholder="Enter Your Last Name" fullWidth name="last_name" value={data.last_name} onChange={handleChange} required sx={{ mb: 2 }} error={errors.last_name}
                helperText={errors.last_name ? "Last name is required" : ""} />

              <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Email </Typography>
              <TextField placeholder="Enter Your Email" fullWidth name="email" value={data.email} onChange={handleChange} required sx={{ mb: 2 }} error={errors.email}
                helperText={errors.email ? "Valid email is required" : ""} />


              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}>Country</Typography>
                  <TextField placeholder="Country" fullWidth name="country" value={data.country} onChange={handleChange} required sx={{ mb: 2 }} error={errors.country}
                    helperText={errors.country ? "Country is required" : ""} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> City</Typography>
                  <TextField placeholder="City" fullWidth name="city" value={data.city} onChange={handleChange} required sx={{ mb: 2 }} error={errors.city}
                    helperText={errors.city ? "City is required" : ""} />
                </Grid>
              </Grid>

              <FormControlLabel
                control={<Checkbox name="agreeTerms" checked={data.agreeTerms} onChange={handleChange} />}
                label={<Typography variant="body2">I agree to E1X's <Link href="#">Terms & Conditions</Link>.</Typography>}
                sx={{ mb: 1 }}
              />
              {errors.agreeTerms && <FormHelperText error>You must agree to the Terms & Conditions</FormHelperText>}

              <FormControlLabel
                control={<Checkbox name="agreePrivacy" checked={data.agreePrivacy} onChange={handleChange} />}
                label={<Typography variant="body2">I understand that E1X will process my information in accordance with their Privacy Policy. I may withdraw my consent through unsubscribe links at any time.</Typography>}
                sx={{ mb: 3 }}
              />
              {errors.agreePrivacy && <FormHelperText error>You must agree to the Privacy Policy</FormHelperText>}
              <Button type="submit" fullWidth variant="contained" sx={{ py: 1.5, backgroundColor: "#E84A1C", "&:hover": { backgroundColor: "#D15424" } }} disabled={!isFormComplete()}>
                Continue
              </Button>


              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Typography variant="body1">Already have an account? <Link component={RouterLink} to={"/talents/login"} sx={{ color: "#E84A1C", textDecoration: "none" }}>Sign In</Link></Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Typography variant="body1">Looking to hire a talent <Link component={RouterLink} to={"/talents/hire"} sx={{ color: "#E84A1C", textDecoration: "none" }}>Click Here</Link></Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}